export default {
  en: {
    menu: {
      orgDetails: 'Organisation details',
      products: 'Products and services',
      thirdParties: 'Critical suppliers',
      assets: 'Assets',
    },
    productSettings: {
      description: 'What products & services do you offer your clients?',
      add: 'Add product',
    },
    assetSettings: {
      subtitle: 'What public domains are associated with your services?',
    },
    criticalSuppliers: {
      subtitle: 'Which suppliers that you work with are critical to your business?',
      hideBanner:
        'To hide any of your critical suppliers from your clients, click the "More" icon next to their name and choose "Hide supplier". ',
      supplier: 'Supplier',
    },
  },
};
